<template>
  <div class="chat-item-bill smd-panel"
       :class="{clickable: unsettled}"
       @click="checkout">
    <img alt="Bill"
         class="chat-item-bill__image"
         :src="$options.BillImage">
    <div class="chat-item-bill__patient-date">
      <div class="chat-item-bill__patient-name">
        {{ patient.name }}
      </div>
      <div class="chat-item-bill__date">
        {{ bill.billDate | formatBillDate }}
      </div>
    </div>
    <div class="chat-item-bill__amount-status">
      <div class="chat-item-bill__amount">
        {{ finalAmount | currency }}
      </div>
      <div class="chat-item-bill__status"
           :class="[bill.status]">
        {{ bill.status | capitalize }}
      </div>
    </div>
  </div>
</template>

<script>
  import {capitalize} from '@/filters';
  import BillImage from '@/assets/images/bill.png';
  import {formatDate} from '@/utils/dates';
  import {BILL_TYPES} from '@/reference/bills';

  export default {
    name: 'chat-item-bill',
    filters: {
      formatBillDate(date) {
        return formatDate(date, 'MMMM DD, YYYY');
      },
      capitalize,
    },
    props: {
      bill: {type: Object, required: true},
      patient: {type: Object, required: true},
    },
    computed: {
      finalAmount() {
        return this.bill.rbgi ? this.bill.billAmount : this.bill.chargeAmount;
      },
      unsettled() {
        return this.bill.status === BILL_TYPES.UNSETTLED;
      },
    },
    methods: {
      checkout() {
        if (this.unsettled) {
          window.open(this.bill.checkoutURL, '_blank');
        }
      },
    },
    BillImage,
  }
</script>

<style lang="scss">
  .chat-item-bill {
    @extend %layout--flex-row-center-x;
    @include border-radius(radius(medium));
    padding: space(m);

    &.clickable {
      cursor: pointer;
    }

    img {
      margin-right: space(m);
    }

    &__amount-status {
      text-align: right;
      margin-left: space(m);
    }

    &__amount {
      @include font-style(Title1)
    }

    &__status {
      @include font-style(Body5);

      &.cleared {
        color: color(green, brand);
      }

      &.unsettled {
        color: color(red, brand);
      }

      &.void {
        color: color(gray, text);
      }
    }

    &__patient-date {
      flex: 1;
    }

    &__patient-name {
      @include font-style(Title4);
      @include responsive(desktop) {
        margin-bottom: space(s);
        font-size: 24px;
      }
    }

    &__date {
      @include font-style(Body3);
    }
  }
</style>
